export class Originador {
  public static readonly DESCRITIVO_GERAL = 'Consignatária';
  public id!: number | null;
  public ativo!: boolean;
  public razaoSocial!: string;
  public nome!: string;
  public cep!: string;
  public endereco!: string;
  public numeroEndereco!: string;
  public complemento!: string;
  public bairro!: string;
  public cidade!: string;
  public uf!: string;
  public telefoneComercial!: string;
  public foneCelular!: string;
  public email!: string;
  public idMatriz!: number;
  public corPrincipal!: string;
  public corSecundaria!: string;
  public corTexto!: string;
  public corCabecalho!: string;
  public corTabela!: string;
  public logoUrl?: string;
  public apiKey?: string;
}